import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Hydrogenetische Moortypen</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<table class="table table-sm table-bordered moortyp-table">
				<thead>
					<tr>
						<th>Hydrog. Moortyp</th>
						<th>Substrat</th>
						<th>Zersetzung</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of rows">
						<td><strong>{{ row.typ }}</strong></td>
						<td class="substrat-cell">{{ row.substrat }}</td>
						<td>{{ row.zersetzung }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	`,
	styles: [`
		.moortyp-table {
			font-size: 0.85rem;
		}
		.moortyp-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
		}
		.moortyp-table td {
			vertical-align: middle;
		}
		.substrat-cell {
			text-align: center;
			font-family: monospace;
		}
	`]
})
export class HydrogenetischerMoortypInfoModalComponent {
	activeModal = inject(NgbActiveModal);

	rows = [
		{ typ: 'Verlandungsmoor', substrat: 'vh', zersetzung: 'mäßig' },
		{ typ: 'Versumpfungsmoor', substrat: 'vh, ih', zersetzung: 'meist hoch' },
		{ typ: 'Kesselmoor', substrat: 'ph, vh', zersetzung: 'gering bis mäßig' },
		{ typ: 'Durchströmungsmoor', substrat: 'vh', zersetzung: 'meist gering bis mäßig' },
		{ typ: 'Quellmoor', substrat: 'ih, ah', zersetzung: 'meist hoch' },
		{ typ: 'Hangmoor', substrat: 'ih, vh', zersetzung: 'mäßig bis hoch' },
		{ typ: 'Hangquellmoor', substrat: 'ih, ah', zersetzung: 'meist hoch' },
		{ typ: 'Überflutungsmoor', substrat: 'ih, ah', zersetzung: 'hoch' },
		{ typ: 'Regenmoor', substrat: 'ph', zersetzung: 'gering bis mäßig' },
	];
}
